/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

export type InquiryDetailResponseDtoFurnishingTypesItem = typeof InquiryDetailResponseDtoFurnishingTypesItem[keyof typeof InquiryDetailResponseDtoFurnishingTypesItem];


export const InquiryDetailResponseDtoFurnishingTypesItem = {
  PARTIAL: 'PARTIAL',
  BY_AGREEMENT: 'BY_AGREEMENT',
  UNFURNISHED: 'UNFURNISHED',
  FULL: 'FULL',
} as const;
